export default __webpack_public_path__ + "static/photo-603b36ee76750e4e2eafb0333c3ccbf4.jpg";